import React from 'react';
import type { IconProps } from './types';

// Small downward caret used by the SearchableSelect trigger.
const CaretDownIcon: React.FC<IconProps> = ({ size = 12, color = 'currentColor', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12" {...props}>
    <path fill={color} d="M6 9L1 4h10z" />
  </svg>
);

export default CaretDownIcon;
